import BaseRoute from 'codecrafters-frontend/utils/base-route';

export default class NotFoundRoute extends BaseRoute {
  allowsAnonymousAccess = true;
}
